import React, { useEffect } from 'react'
import './ErrorModal.css'
import { useTranslation } from 'react-i18next'

const ErrorModal = ({ open, onClose, title, message }) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="ErrorModal-overlay" onClick={onClose}>
            <div
                className="ErrorModal-card"
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="error-modal-title"
                aria-describedby="error-modal-message"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="ErrorModal-icon">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#C0392B" strokeWidth="1.6" />
                        <path d="M12 7.5V13" stroke="#C0392B" strokeWidth="1.6" strokeLinecap="round" />
                        <circle cx="12" cy="16.3" r="1" fill="#C0392B" />
                    </svg>
                </div>
                <p id="error-modal-title" className="ErrorModal-title">{title}</p>
                <p id="error-modal-message" className="ErrorModal-message">{message}</p>
                <button type="button" className="ErrorModal-close" onClick={onClose}>{t('ErrorModalClose')}</button>
            </div>
        </div>
    )
}

export default ErrorModal
